// extracted by mini-css-extract-plugin
export default {"innerWrapper":"YA-z","tooltipWrapper":"ZA-z","icon":"_A-z","tooltip":"aB-z","content":"bB-z"};